"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "val-brembilla": {
    "d4a05c75": [{
      "hkey": "853495d7",
      "slug": "val-brembilla",
      "name": "Val Brembilla",
      "primary": true,
      "skipSearch": false
    }],
    "cadelfoglia": [{
      "hkey": "853495d7",
      "slug": "val-brembilla",
      "name": "Val Brembilla",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "80a00335": [{
      "hkey": "5374fa6a",
      "slug": "catremerio",
      "name": "Catremerio",
      "primary": true,
      "skipSearch": false
    }],
    "catramerio": [{
      "hkey": "5374fa6a",
      "slug": "catremerio",
      "name": "Catremerio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2698b24a": [{
      "hkey": "853495d7",
      "slug": "val-brembilla",
      "name": "Val Brembilla",
      "primary": true,
      "skipSearch": false
    }],
    "cerro": [{
      "hkey": "853495d7",
      "slug": "val-brembilla",
      "name": "Val Brembilla",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "63d4eed5": [{
      "hkey": "1a4180a9",
      "slug": "chignolo-unizzi",
      "name": "Chignolo-Unizzi",
      "primary": true,
      "skipSearch": false
    }],
    "chignolo-foppetta": [{
      "hkey": "1a4180a9",
      "slug": "chignolo-unizzi",
      "name": "Chignolo-Unizzi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "cfd2651b": [{
      "hkey": "c92a4436",
      "slug": "foppa-calda-musita",
      "name": "Foppa Calda-Musita",
      "primary": true,
      "skipSearch": false
    }],
    "foppacalda": [{
      "hkey": "c92a4436",
      "slug": "foppa-calda-musita",
      "name": "Foppa Calda-Musita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "val-brembilla"
    }],
    "0fcab2a7": [{
      "hkey": "853495d7",
      "slug": "val-brembilla",
      "name": "Val Brembilla",
      "primary": true,
      "skipSearch": false
    }],
    "forcella": [{
      "hkey": "853495d7",
      "slug": "val-brembilla",
      "name": "Val Brembilla",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "07136b87": [{
      "hkey": "c92a4436",
      "slug": "foppa-calda-musita",
      "name": "Foppa Calda-Musita",
      "primary": true,
      "skipSearch": false
    }],
    "musita": [{
      "hkey": "c92a4436",
      "slug": "foppa-calda-musita",
      "name": "Foppa Calda-Musita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "val-brembilla"
    }]
  }
};
exports["default"] = _default;